import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { CardButtonItem, CardLinkItem } from '~/views/pages/dotcom/schedule/styles';

export const LargeContainer = styled.span`
    ${BaseStyle.Mixins.fontStyles.ui['16m']}
    display: none;

    ${BaseStyle.Mixins.screenSizes.large} {
        display: initial;
    }
`;

export const SmallContainer = styled.div`
    align-items: center;
    display: flex;
    height: 35px;
    padding: 0 8px;
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.large} {
        display: none;
    }
`;

export const Item = styled.div<{ $align?: string }>`
    flex: ${({ $align }) => ($align === 'center' ? 2 : 1)};
    max-height: 24px;
    max-width: 50vw;
    text-align: ${({ $align }) => $align || 'initial'};
`;

export const IconContainer = styled.span<{ $isDarkPage?: boolean }>`
    display: flex;
    justify-content: end;

    svg {
        fill: ${({ $isDarkPage, theme }) => ($isDarkPage ? theme.Text.primary : theme.Utility.cta)};
        ${BaseStyle.Mixins.fontStyles.ui['24m']}
    }
`;

export const PopperContent = styled.div`
    background: ${({ theme }) => theme.Surface.primary};
    padding: 1em;

    ${CardLinkItem}:last-child {
        border-bottom: initial;
    }

    ${CardButtonItem}:last-child {
        border-bottom: initial;
    }
`;
